import { Skeleton, TopicLink as DesignSystemTopicLink } from '@all-manager/design-system-v2';
import type { MouseEvent } from 'react';

import { useRouterLinkClick } from '../../../../hooks/useRouterLinkClick';
import { useSpacePath } from '../../../../hooks/useSpacePath';
import { useGetSubTopicByIdWithTopic } from '../../api/useGetSubTopicByIdWithTopic';

type Props = {
  subTopicId: string;
  variant?: 'body1' | 'body1Emphasis' | 'body2' | 'body2Emphasis' | 'caption';
  color?: string;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  className?: string;
  fontSize?: string | number;
  sx?: Record<string, unknown>;
};

export default function TopicLink(props: Props) {
  const spacePath = useSpacePath();
  const targetUrl = spacePath(`/topics/${props.subTopicId}`);
  const handleClick = useRouterLinkClick(targetUrl, props.onClick);
  const { data, isLoading } = useGetSubTopicByIdWithTopic(props.subTopicId);

  if (isLoading) {
    return <Skeleton width={140} height={props.variant === 'caption' ? 16 : 20} />;
  }

  if (!data) {
    return null;
  }

  return (
    <DesignSystemTopicLink
      topicName={data.topics.name}
      subTopicName={data.name}
      href={targetUrl}
      onClick={handleClick}
      variant={props.variant ?? 'body2'}
      color={props.color}
    />
  );
}
